// Appels HTTP typés vers /api/reminder-templates/* (Lot 4B — UI admin).

import { api } from "./client";
import type {
  ReminderTemplatePreviewRequest,
  ReminderTemplatePreviewResponse,
  ReminderTemplatePublic,
  ReminderTemplateUpdate,
} from "./types";

export const reminderTemplatesApi = {
  list: () =>
    api.get<ReminderTemplatePublic[]>("/api/reminder-templates"),

  /** Upsert — crée si template_key inconnu, sinon remplace subject/body. */
  save: (templateKey: string, payload: ReminderTemplateUpdate) =>
    api.put<ReminderTemplatePublic>(
      `/api/reminder-templates/${encodeURIComponent(templateKey)}`,
      payload,
    ),

  preview: (templateKey: string, payload: ReminderTemplatePreviewRequest) =>
    api.post<ReminderTemplatePreviewResponse>(
      `/api/reminder-templates/${encodeURIComponent(templateKey)}/preview`,
      payload,
    ),
};
